<template>
	<v-overlay :value="saving" :opacity="0.7">
		<v-progress-circular indeterminate size="64"></v-progress-circular>
	</v-overlay>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalOverlayLoaderStore } from '@/plugins/clientModels/store/globalOverlayLoaderStore';
export default {
	name: 'GlobalOverlayLoader',
	computed: {
		...mapState(useGlobalOverlayLoaderStore, ['saving']),
	},
};
</script>
